
<template>
	<!-- 设置表格显示字段 -->
	<el-dialog
		:title="$t('webList.tradeType.tableField')"
		:visible.sync="visibleValue"
		width="530px"
		@close="closeTableSetting"
	>
		<div class="container-header">
			<el-row :gutter="20">
				<el-col :span="12">
					<p>{{ $t("webList.tradeType.fixedField") }}</p>
					<el-checkbox
						v-for="item in tableSetting_disabled"
						:key="item.prop"
						v-model="item.value"
						class="normal-checkbox"
						size="small"
						disabled
						style="margin-top: 10px; display: block"
					>{{ item[lang] || item.en || item.zh }}</el-checkbox>
				</el-col>
				<el-col :span="12">
					<p>{{ $t("webList.tradeType.optionalField") }}</p>
					<el-checkbox
						v-for="item in tableSetting_active"
						:key="item.prop"
						v-model="item.value"
						class="normal-checkbox"
						size="small"
						style="margin-top: 10px; display: block"
						@change="change"
					>{{ item[lang] || item.en || item.zh }}</el-checkbox>
				</el-col>
			</el-row>
		</div>
		<div slot="footer" class="ac">
			<el-button class="foot-button" round @click="$emit('hide')">{{
				$t("webList.addWebDialog.cancel")
			}}</el-button>
			<el-button
				class="foot-button"
				round
				type="primary"
				:loading="saveLoading"
				@click="saveTableSetting"
			>{{ $t("webList.tradeType.saveSeting") }}</el-button>
		</div>
	</el-dialog>
</template>

<script>
import {
	getClientProperty,
	saveClientProperty
} from '@/api/modules/webSiteApi'
export default {
	name: 'TableSetting',
	props: {
		queryType: {
			type: String,
			default: 'trade_query_habit'
		},
		visible: {
			type: Boolean,
			default: true
		},
		tableProperty: {
			type: Array,
			default: function() {
				return [
					{
						prop: 'storeName',
						zh: '网站/群组',
						en: 'Website/Group'
					},
					{
						prop: 'transactionTimeStr',
						zh: '交易时间',
						en: 'Transaction Time'
					},
					{
						prop: 'outFlowId',
						zh: '交易流水号',
						en: 'Purchase Transaction ID'
					},
					{
						prop: 'merchantTransactionIdStr',
						zh: '网站订单号',
						en: 'Merchant Transaction ID'
					},
					{
						prop: 'arn',
						zh: 'ARN',
						en: 'ARN'
					},
					{
						prop: 'merchantId',
						zh: '用户',
						en: 'Customer'
					},
					{
						prop: 'email',
						zh: '邮箱/手机号',
						en: 'Email/phone number'
					},
					{
						prop: 'paymentBrand',
						zh: '支付方式',
						en: 'Payment Method'
					},
					{
						prop: 'currency',
						zh: '交易币种',
						en: 'Currency'
					},

					{
						prop: 'amount',
						zh: '交易金额',
						en: 'Amount'
					},
					{
						prop: 'transactionType',
						zh: '交易类型',
						en: 'Transaction Type'
					},
					{
						prop: 'isThreeD',
						zh: '3DS验证',
						en: '3DS'
					},
					{
						prop: 'isToken',
						zh: 'Token支付',
						en: 'Token'
					},
					{
						prop: 'status',
						zh: '交易状态',
						en: 'Status'
					},
					{
						prop: 'issueCountry',
						zh: '卡bin国家',
						en: 'Card Bin Country'
					},
					{
						prop: 'errorMessage',
						zh: '失败原因',
						en: 'Error Message'
					},
					{
						prop: 'shopifyOrderId',
						zh: 'Shopify 订单号',
						en: 'Shopify Transaction ID'
					},
					{
						prop: 'transactionId',
						zh: '交易订单号',
						en: 'Transaction ID'
					},
					{
						prop: 'tradeModel',
						zh: '交易模式',
						en: 'Trading mode'
					},
					{
						prop: 'desensitizedCardNo',
						zh: '脱敏卡号',
						en: 'Desensitized card numbers'
					}
				]
			}
		}
	},
	data() {
		return {
			saveLoading: false,
			lang: this.$i18n.locale,
			tableSetting: null,
			tableSetting_disabled: [],
			tableSetting_active: []
		}
	},
	computed: {
		visibleValue: {
			get() {
				return this.visible
			},
			set() {}
		}
	},
	created() {
		this.getTableSetting()
	},
	mounted() {},
	methods: {
		getTableSetting() {
			getClientProperty({
				propertyType: this.queryType
	  }).then((res) => {
				const propertyObject = JSON.parse(res.propertyValue)
		  console.error(propertyObject)
				const tableSetting_disabled = this.tableProperty.filter(
					(item) => propertyObject[item.prop] == 9
				)
				const tableSetting_active = this.tableProperty.filter(
					(item) => propertyObject[item.prop] != 9
				)

				// 固定字段
				this.tableSetting_disabled = tableSetting_disabled.map(
					(item) => {
						item['value'] = true
						return item
					}
				)

				// 可修改字段
				this.tableSetting_active = tableSetting_active.map((item) => {
					item['value'] =
						propertyObject[item.prop] == 1
					return item
				})

				// 表格显示字段
				const tableProperty_visible = this.tableProperty.filter(
					(item) =>
						propertyObject[item.prop] == 9 ||
						propertyObject[item.prop] == 1
				)

				this.$emit('fetch-table-prop', tableProperty_visible)
			})
		},
		saveTableSetting() {
			this.saveLoading = true

			const propertyValue = {}

			this.tableSetting_disabled.forEach((item) => {
				propertyValue[item.prop] = 9
			})
			this.tableSetting_active.forEach((item) => {
				propertyValue[item.prop] = item.value ? 1 : 0
			})

			const params = {
				propertyType: this.queryType,
				propertyValue: JSON.stringify(propertyValue)
			}

			saveClientProperty(params)
				.then((res) => {
					if (res === 'SUCCESS') {
						this.$message.success(
							this.$t('webList.tradeType.save')
						)
						this.tableHeaderDialog = false
						this.$emit('hide')
					} else {
						this.$message.error(
							this.$t('webList.tradeType.savefaile')
						)
					}
					this.saveLoading = false
				})
				.finally(() => {
					this.getTableSetting()
				})
		},
		change() {
			this.tableSetting_active = [...this.tableSetting_active]
		},
		closeTableSetting() {
			this.$emit('close')
		}
	}
}
</script>
<style lang='scss' scoped>
</style>
